import { TFunction } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";

import { ControlSchedulingType } from "./types";

export function formatControlSchedulingType(
    schedulingType: ControlSchedulingType,
    t: TFunction
): string {
    switch (schedulingType) {
        case "Date":
            return t("CreateControl_Recurrence_Manual");
        case "Weekly":
            return t("CreateControl_Recurrence_Interval_Weekly");
        case "Monthly":
            return t("CreateControl_Recurrence_Interval_Monthly");
        case "EveryTwoMonths":
            return t("CreateControl_Recurrence_Interval_Every2Months");
        case "Quarterly":
            return t("CreateControl_Recurrence_Interval_Quarterly");
        case "HalfYearly":
            return t("CreateControl_Recurrence_Interval_HalfYearly");
        case "Yearly":
            return t("CreateControl_Recurrence_Interval_Yearly");
        default:
            return assertNever(schedulingType);
    }
}

export function unformatControlSchedulingType(
    schedulingType: string,
    t: TFunction
): ControlSchedulingType {
    switch (schedulingType) {
        case t("CreateControl_Recurrence_Manual"):
            return "Date";
        case t("CreateControl_Recurrence_Interval_Weekly"):
            return "Weekly";
        case t("CreateControl_Recurrence_Interval_Monthly"):
            return "Monthly";
        case t("CreateControl_Recurrence_Interval_Every2Months"):
            return "EveryTwoMonths";
        case t("CreateControl_Recurrence_Interval_Quarterly"):
            return "Quarterly";
        case t("CreateControl_Recurrence_Interval_HalfYearly"):
            return "HalfYearly";
        case t("CreateControl_Recurrence_Interval_Yearly"):
            return "Yearly";
        default:
            throw new Error(
                "Unexpected formatted scheduling type: " + schedulingType
            );
    }
}
